/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CommissionParitaireGridDto
 */
export interface CommissionParitaireGridDto {
    /**
     * 
     * @type {number}
     * @memberof CommissionParitaireGridDto
     */
    idcommissionParitaire?: number;
    /**
     * 
     * @type {string}
     * @memberof CommissionParitaireGridDto
     */
    libelle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommissionParitaireGridDto
     */
    code?: string | null;
}

/**
 * Check if a given object implements the CommissionParitaireGridDto interface.
 */
export function instanceOfCommissionParitaireGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CommissionParitaireGridDtoFromJSON(json: any): CommissionParitaireGridDto {
    return CommissionParitaireGridDtoFromJSONTyped(json, false);
}

export function CommissionParitaireGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommissionParitaireGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idcommissionParitaire': !exists(json, 'idcommissionParitaire') ? undefined : json['idcommissionParitaire'],
        'libelle': !exists(json, 'libelle') ? undefined : json['libelle'],
        'code': !exists(json, 'code') ? undefined : json['code'],
    };
}

export function CommissionParitaireGridDtoToJSON(value?: CommissionParitaireGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idcommissionParitaire': value.idcommissionParitaire,
        'libelle': value.libelle,
        'code': value.code,
    };
}

